module.exports = __webpack_public_path__ + "static/media/Connection Broke.2cbf3d07.png";